export enum TypePropertyLocalStorage {
  USER = 'user',
  SUBSCRIPTION_FROM_LANDING = 'subscriptionFromLanding',
  PREVIEW_URL = 'previewURL',
  IS_FROM_AUTH = 'isFromAuth',
  IS_FROM_CONFIGURATION = 'isFromConfig',
  ENLACE_TOKEN = 'enlaceToken',
  LAST_BREADCRUMB = 'lastBreadCrumb'
}
